import { useNavigate } from "react-router-dom";
import { FC } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Unstable_Grid2";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SvgIcon from "@mui/material/SvgIcon";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import useUserDataProvider from "src/contexts/userData-context";
import { QuillEditor } from "src/components/quill-editor";
import MarkEmailReadRoundedIcon from "@mui/icons-material/MarkEmailReadRounded";
import { OtherUserDataObj } from "src/types/snugtotal";
import CardActions from "@mui/material/CardActions";
import { VideoDropDownMenu } from "src/components/video-dropdown-menu";
import { usePopover } from "src/hooks/use-popover";
import { useDialog } from "src/hooks/use-dialog";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import PlusIcon from "@untitled-ui/icons-react/build/esm/Plus";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import MedicationOutlined from "@mui/icons-material/MedicationOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";

import { VideoAskDialog } from "src/sections/dashboard/videoask-dialog";
import Express from "src/pages/dashboard/express";
import Assets from "src/pages/dashboard/assets";

import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";

import { useAuth } from "src/hooks/use-auth";
import { paths } from "src/paths";
import { useOtherUserDataStore } from "src/hooks/snug/use-otherUserData";
import { LoadingButton } from "@mui/lab";
import { useVideoAskRecordings } from "src/hooks/snug/use-videoask";

import useHousehold, { ExperienceFlag } from "src/contexts/household-context";
import IconButton from "@mui/material/IconButton";
import DotsVerticalIcon from "@untitled-ui/icons-react/build/esm/DotsVertical";
import toast from "react-hot-toast";

export const Home: FC = () => {
  const [popoverId, setPopoverId] = useState<string | null>(null);
  const popover = usePopover<HTMLButtonElement>();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // const [celebrationDialogOpen, setCelebrationDialogOpen] = useState(false);
  const dialog = useDialog();


  // const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));

  const { user } = useAuth();
  const { userData } = useUserDataProvider();
  const { experienceFlag } = useHousehold();
  const {
    otherUserData,
    otherUserDataSavingNew,
    otherUserDataLoading,
    handleAddOrUpdateOtherUserData,
  } = useOtherUserDataStore(userData?.ud_id || null);

  const { recordings, deleteRecording, fetchRecordings } =
    useVideoAskRecordings(userData?.ud_id || null);

  const navigate = useNavigate();
  // const estateDocStore = useEstateDocumentStore(userData?.ud_id || null);

  // const getTimeBasedGreeting = () => {
  //   const hour = new Date().getHours();
  //   if (hour < 12) return "Good morning";
  //   if (hour < 18) return "Good afternoon";
  //   return "Good evening";
  // };

  // const getTimeBasedEmoji = () => {
  //   const hour = new Date().getHours();
  //   // Moon for evening (6pm onwards)
  //   if (hour >= 18) return "🌙";
  //   // Sun for morning and afternoon
  //   return "☀️";
  // };

  // const getFormattedDate = () => {
  //   const date = new Date();
  //   const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
  //   const monthName = date.toLocaleDateString("en-US", { month: "long" });
  //   const day = date.getDate();
  //
  //   // Add ordinal suffix (st, nd, rd, th)
  //   const getOrdinalSuffix = (day: number) => {
  //     if (day > 3 && day < 21) return "th";
  //     switch (day % 10) {
  //       case 1:
  //         return "st";
  //       case 2:
  //         return "nd";
  //       case 3:
  //         return "rd";
  //       default:
  //         return "th";
  //     }
  //   };
  //
  //   return `${dayName}, ${monthName} ${day}${getOrdinalSuffix(day)}`;
  // };

  const [content, setContent] = useState<string>(
    otherUserData.words_of_wisdom || ""
  );

  // Function to handle content change
  const handleContentChange = (content: string) => {
    setContent(content);
  };

  const handleClear = () => {
    setContent("");
  };

  const handleSave = async () => {
    // Here we would include the editor content in the object we want to save
    const userDataToSave: OtherUserDataObj = {
      // ...other user data fields
      id: otherUserData.id || null,
      words_of_wisdom: content,
    };
    const result = await handleAddOrUpdateOtherUserData(userDataToSave);
    if (result) {
      toast.success("Letter to Family saved successfully");
    }
  };

  useEffect(() => {
    setContent(otherUserData?.words_of_wisdom || "");
  }, [otherUserData]);

  // Check if user should see the platform celebration dialog
  // useEffect(() => {
  //   if (userData?.ud_id && !userDataInitialLoading) {
  //     // Check if user has premium access (not FREE tier)
  //     const hasPremiumAccess =
  //       userData.total_payment_tier &&
  //       userData.total_payment_tier.total_payment_tier !== "FREE";

  //     if (hasPremiumAccess) {
  //       const celebrationKey = `platform_celebration_shown_${userData.ud_id}`;
  //       const hasSeenCelebration = localStorage.getItem(celebrationKey);

  //       if (!hasSeenCelebration) {
  //         setCelebrationDialogOpen(true);
  //       }
  //     }
  //   }
  // }, [userData, userDataInitialLoading]);

  // const mostRecentOfficialHCD =
  //   estateDocStore.hcds.filter(
  //     (d) => d.type === "HEALTHCARE_DIRECTIVE" && d.status !== "IN_PROGRESS"
  //   )[0] || null;

  // const mostRecentOfficialWillOrTrust =
  //   estateDocStore.willsAndTrusts.filter(
  //     (d) => d.status !== "IN_PROGRESS"
  //   )[0] || null;

  // const mostRecentOfficialFpoa =
  //   estateDocStore.fpoas.filter(
  //     (d) =>
  //       d.type === "FINANCIAL_POWER_OF_ATTORNEY" && d.status !== "IN_PROGRESS"
  //   )[0] || null;

  // const advisorUploadProcessing =
  //   estateDocStore.estateDocuments.filter(
  //     (d) =>
  //       d.document_source === "ADVISOR_UPLOAD" &&
  //       d.status === "ANALYSIS_PENDING"
  //   ).length > 0;

  usePageView();

  // const parseFirstName = (name: string | undefined): string => {
  //   if (name) {
  //     const nameArray = name.split(" ");
  //     return nameArray[0];
  //   } else {
  //     return "";
  //   }
  // };

  // const { selectedHousehold } = useHousehold();
  // const hOH = selectedHousehold?.head_of_household;
  // const estate_plan_foundation = hOH?.estate_plan_foundation;

  return (
    <>
      <Seo title="Total Estate Planning" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pb: 8,
          px: 0,
          backgroundColor: "#fcfcfc",
        }}
      >
        <Box sx={{ width: "100%", backgroundColor: "#fcfcfc" }}>
          <Container maxWidth="lg" sx={{ backgroundColor: "#fcfcfc", px: 0 }}>
            <Stack
              spacing={3}
              sx={{ px: { xs: 0, sm: 2, md: 4 }, textAlign: "center", mt: 3 }}
            >
              <Stack
                direction="row"
                spacing={0}
                justifyContent="start"
                flexWrap="wrap"
                sx={{ gap: 1 }}
                alignItems={"center"}
              >
                <Typography variant="caption" color="text">
                  Quick start:
                </Typography>
                <Tooltip
                  title="Create and view essential estate planning documents, including Wills and Trusts"
                  arrow
                >
                  <Button
                    variant="outlined"
                    color="inherit"
                    size="small"
                    sx={{
                      py: 0.3,
                      px: 1.5,
                      fontSize: "0.75rem",
                      borderRadius: 0.6,
                      border: "1px solid #cfcfcf",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                      backgroundColor: "white",
                      "&:hover": { backgroundColor: "#f5f5f5" },
                    }}
                    onClick={() => {
                      const element =
                        document.getElementById("documents-section");
                      if (element) {
                        const yOffset = -80;
                        const y =
                          element.getBoundingClientRect().top +
                          window.pageYOffset +
                          yOffset;
                        window.scrollTo({ top: y, behavior: "smooth" });
                      }
                    }}
                  >
                    Essential Documents
                  </Button>
                </Tooltip>
                
                <Tooltip
                  title="Write a personal letter to loved ones to share your intent and goals"
                  arrow
                >
                  <Button
                    variant="outlined"
                    color="inherit"
                    size="small"
                    sx={{
                      py: 0.3,
                      px: 1.5,
                      fontSize: "0.75rem",
                      borderRadius: 0.6,
                      border: "1px solid #cfcfcf",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                      backgroundColor: "white",
                      "&:hover": { backgroundColor: "#f5f5f5" },
                    }}
                    onClick={() => {
                      const element = document.getElementById("letter-section");
                      if (element) {
                        const yOffset = -80;
                        const y =
                          element.getBoundingClientRect().top +
                          window.pageYOffset +
                          yOffset;
                        window.scrollTo({ top: y, behavior: "smooth" });
                      }
                    }}
                  >
                    Letter to Family
                  </Button>
                </Tooltip>
                <Tooltip
                  title="Record and save video messages for future generations to cherish forever"
                  arrow
                >
                  <Button
                    variant="outlined"
                    color="inherit"
                    size="small"
                    sx={{
                      py: 0.3,
                      px: 1.5,
                      fontSize: "0.75rem",
                      borderRadius: 0.6,
                      border: "1px solid #cfcfcf",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                      backgroundColor: "white",
                      "&:hover": { backgroundColor: "#f5f5f5" },
                    }}
                    onClick={() => {
                      const element = document.getElementById("video-section");
                      if (element) {
                        const yOffset = -80;
                        const y =
                          element.getBoundingClientRect().top +
                          window.pageYOffset +
                          yOffset;
                        window.scrollTo({ top: y, behavior: "smooth" });
                      }
                    }}
                  >
                    Video Messages
                  </Button>
                </Tooltip>
                <Tooltip
                  title="Organize all your important life details and information in one secure place"
                  arrow
                >
                  <Button
                    variant="outlined"
                    color="inherit"
                    size="small"
                    sx={{
                      py: 0.3,
                      px: 1.5,
                      fontSize: "0.75rem",
                      borderRadius: 0.6,
                      border: "1px solid #cfcfcf",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                      backgroundColor: "white",
                      "&:hover": { backgroundColor: "#f5f5f5" },
                    }}
                    onClick={() => {
                      const element =
                        document.getElementById("planning-section");
                      if (element) {
                        const yOffset = -80;
                        const y =
                          element.getBoundingClientRect().top +
                          window.pageYOffset +
                          yOffset;
                        window.scrollTo({ top: y, behavior: "smooth" });
                      }
                    }}
                  >
                    Total Planning
                  </Button>
                </Tooltip>
                <Tooltip
                  title="See your plan for managing assets and how they flow to your beneficiaries"
                  arrow
                >
                  <Button
                    variant="outlined"
                    color="inherit"
                    size="small"
                    sx={{
                      py: 0.3,
                      px: 1.5,
                      fontSize: "0.75rem",
                      borderRadius: 0.6,
                      border: "1px solid #cfcfcf",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                      backgroundColor: "white",
                      "&:hover": { backgroundColor: "#f5f5f5" },
                    }}
                    onClick={() => {
                      const element = document.getElementById("assets-section");
                      if (element) {
                        const yOffset = -80;
                        const y =
                          element.getBoundingClientRect().top +
                          window.pageYOffset +
                          yOffset;
                        window.scrollTo({ top: y, behavior: "smooth" });
                      }
                    }}
                  >
                    Asset Planning
                  </Button>
                </Tooltip>
              </Stack>
            </Stack>
          </Container>
        </Box>

        <Box
          sx={{
            // backgroundImage:
            //   'url("https://s3.us-east-2.amazonaws.com/assets.getsnug.com/files/sand_opt.png")',
            // backgroundRepeat: "no-repeat",
            // backgroundSize: "cover",
            // backgroundPosition: { xs: "left", md: "right" },
            mt: 2,
            py: 6,
          }}
        >
          <Container maxWidth="lg">
            <Stack
              spacing={10}
              divider={<Divider sx={{ borderColor: "#e7e7e7" }} />}
            >
              <Stack
                spacing={3}
                sx={{ mb: 8, mt: 4, px: { xs: 0, sm: 2, md: 4 } }}
                id="documents-section"
              >
                <Stack spacing={1.5} sx={{ textAlign: "left" }}>
                  {experienceFlag === ExperienceFlag.READONLY ? (
                    <Typography variant="h5">Essential documents</Typography>
                  ) : (
                    <Typography variant="h5">
                      Your essential documents
                    </Typography>
                  )}
                  {experienceFlag === ExperienceFlag.READONLY ? (
                    <Typography sx={{ mt: 2 }} variant="body2">
                      The key documents to reference for the estate plan.
                    </Typography>
                  ) : (
                    <Typography sx={{ mt: 2 }} variant="body2">
                      A plan built around your family, your finances, and your
                      goals.
                    </Typography>
                  )}
                </Stack>

                <Box sx={{ mt: 5 }}>
                  <Express useIndexPaths />
                </Box>
              </Stack>

              <Stack
                spacing={3}
                sx={{ mb: 8, mt: 4, px: { xs: 0, sm: 2, md: 4 } }}
                id="letter-section"
              >
                <Stack spacing={1.5} sx={{ textAlign: "left" }}>
                  <Typography variant="h5">Your letter to family</Typography>
                  <Typography sx={{ mt: 2 }} variant="body2">
                    A letter to family can provide your thoughts and wishes for
                    future generations.
                  </Typography>
                </Stack>

                <Box sx={{ mt: 5 }}></Box>

                <Grid
                  container
                  spacing={{
                    lg: 0,
                  }}
                >
                  <Grid xs={12} sm={12} lg={12}>
                    <Stack spacing={3}>
                      <QuillEditor
                        value={content}
                        onChange={handleContentChange}
                        readOnly={
                          experienceFlag === ExperienceFlag.READONLY ||
                          otherUserDataLoading
                        }
                        placeholder="Write your letter to family"
                        sx={{ height: 330, mr: 4, backgroundColor: "#fff" }}
                        modules={
                          experienceFlag === ExperienceFlag.READONLY
                            ? { toolbar: false }
                            : { toolbar: true }
                        }
                      />
                      <Stack direction="row" spacing={1}>
                        <LoadingButton
                          variant="contained"
                          disabled={
                            experienceFlag === ExperienceFlag.READONLY ||
                            otherUserDataLoading
                          }
                          loading={otherUserDataSavingNew}
                          startIcon={<MarkEmailReadRoundedIcon />}
                          onClick={handleSave}
                          sx={{ borderRadius: 1 }}
                          size="small"
                        >
                          Save changes
                        </LoadingButton>
                        <Button
                          variant="text"
                          disabled={experienceFlag === ExperienceFlag.READONLY}
                          color="inherit"
                          onClick={handleClear}
                          sx={{ borderRadius: 1 }}
                          size="small"
                        >
                          Clear
                        </Button>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </Stack>

              <Stack
                spacing={3}
                sx={{ mb: 8, mt: 4, px: { xs: 0, sm: 2, md: 4 } }}
                id="video-section"
              >
                <Stack spacing={1.5} sx={{ textAlign: "left" }}>
                  <Typography variant="h5">Your video messages</Typography>
                  <Typography sx={{ mt: 2 }} variant="body2">
                    Leave video messages for loved ones to cherish forever.
                  </Typography>
                </Stack>

                <Box sx={{ mt: 5 }}>
                  {recordings.length > 0 ? (
                    <Grid container spacing={0}>
                      {recordings.map((recording) =>
                        recording.answers?.map((a: any) =>
                          a.share_url ? (
                            <Grid
                              key={a.id}
                              xs={12}
                              sm={6}
                              md={4}
                              lg={3}
                              sx={{ pr: 3, pb: 3 }}
                            >
                              <Card
                                sx={{
                                  position: "relative",
                                  bgcolor: "#FAF9F8",
                                  border: "1px solid #e7e7e7",
                                  borderRadius: 1,
                                }}
                                variant="outlined"
                              >
                                <IconButton
                                  sx={{
                                    position: "absolute",
                                    top: 5,
                                    right: 5,
                                    backgroundColor: "white",
                                  }}
                                  size="small"
                                  onClick={(event) => {
                                    setPopoverId(recording.id);
                                    setAnchorEl(event.currentTarget);
                                    popover.handleOpen();
                                  }}
                                >
                                  <SvgIcon>
                                    <DotsVerticalIcon />
                                  </SvgIcon>
                                </IconButton>
                                <Stack
                                  alignItems="center"
                                  direction={{
                                    xs: "column",
                                    sm: "row",
                                  }}
                                  spacing={3}
                                  sx={{
                                    px: 0,
                                    py: 0,
                                  }}
                                >
                                  <a
                                    href={a.share_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={a.thumbnail}
                                      alt={`VideoAsk Recording`}
                                      style={{
                                        width: "100%",
                                        borderRadius: "4px 4px 0 0",
                                      }}
                                    />
                                  </a>
                                </Stack>
                                <Divider />
                                <CardActions sx={{ justifyContent: "center" }}>
                                  <Typography variant="caption" sx={{ py: 1 }}>
                                    {a.created_at
                                      ? `Recording from ${new Date(
                                          a.created_at
                                        ).toLocaleDateString()}`
                                      : ""}
                                  </Typography>
                                </CardActions>
                              </Card>
                            </Grid>
                          ) : null
                        )
                      )}
                    </Grid>
                  ) : (
                    <Grid container spacing={3}>
                      <Grid xs={12}>
                        <Card
                          variant="outlined"
                          sx={{
                            p: 4,
                            textAlign: "center",
                            bgcolor: "#fff",
                            border: "1px solid #e7e7e7",
                            borderRadius: 1,
                          }}
                        >
                          <Typography variant="body2" color="text.secondary">
                            No video messages yet. Create your first one to
                            leave a lasting message for loved ones.
                          </Typography>
                        </Card>
                      </Grid>
                    </Grid>
                  )}

                  {experienceFlag !== ExperienceFlag.READONLY && (
                    <Button
                      startIcon={
                        <SvgIcon>
                          <PlusIcon />
                        </SvgIcon>
                      }
                      variant="text"
                      size="small"
                      sx={{
                        mt: 3,
                        borderRadius: 100,
                        color: "#6C737F",
                        "&:hover": { bgcolor: "#F5F5F5" },
                      }}
                      onClick={() => {
                        dialog.handleOpen();
                      }}
                    >
                      Add video message
                    </Button>
                  )}
                </Box>
              </Stack>

              <Stack
                spacing={3}
                sx={{ mb: 8, mt: 4, px: { xs: 0, sm: 2, md: 4 } }}
                id="planning-section"
              >
                <Stack spacing={3}>
                  <Stack spacing={1.5} sx={{ textAlign: "left" }}>
                    {experienceFlag === ExperienceFlag.READONLY ? (
                      <Typography variant="h5">
                        Other important details
                      </Typography>
                    ) : (
                      <Typography variant="h5">Your life's details</Typography>
                    )}

                    {experienceFlag === ExperienceFlag.READONLY ? (
                      <Typography sx={{ mt: 2 }} variant="body2">
                        View and reference all of life's other important details
                        in one place.
                      </Typography>
                    ) : (
                      <Typography sx={{ mt: 2 }} variant="body2">
                        Organizing all of life's details in one place, to leave
                        a legacy and not a mess.
                      </Typography>
                    )}
                  </Stack>

                  <Box sx={{ mt: 5 }}></Box>

                  <Stack spacing={3}>
                    <Box>
                      <Grid
                        container
                        spacing={{
                          xs: 3,
                          lg: 4,
                        }}
                      >
                        <Grid xs={6} sm={4} lg={3}>
                          <Card
                            variant="outlined"
                            sx={{
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              border: "1px solid #e7e7e7",
                              borderRadius: 1,
                              cursor: "pointer",
                              backgroundColor: "#fff",
                              "&:hover": { backgroundColor: "#FAF9F8" },
                            }}
                            onClick={() =>
                              navigate(
                                paths.dashboard.personal(userData?.ud_id || "")
                              )
                            }
                          >
                            <CardContent
                              sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                p: 2.5,
                                pb: 1,
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={2}
                                alignItems="center"
                              >
                                <Box
                                  sx={{
                                    p: 1,
                                    borderRadius: 1,
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #eeeeee",
                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <SvgIcon>
                                    <PeopleOutlineIcon />
                                  </SvgIcon>
                                </Box>

                                <Typography
                                  color="text.primary"
                                  variant="subtitle1"
                                >
                                  Personal
                                </Typography>
                              </Stack>
                              <Typography
                                color="text.secondary"
                                sx={{ mt: 1, flex: 1 }}
                                variant="body2"
                              >
                                Personal contacts, pets, advisors, and personal
                                history.
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <Button
                                color="inherit"
                                endIcon={
                                  <SvgIcon>
                                    <ArrowForwardOutlinedIcon />
                                  </SvgIcon>
                                }
                                size="small"
                                onClick={() =>
                                  navigate(
                                    paths.dashboard.personal(
                                      userData?.ud_id || ""
                                    )
                                  )
                                }
                              >
                                Get started
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>
                        <Grid xs={6} sm={4} lg={3}>
                          <Card
                            variant="outlined"
                            sx={{
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              border: "1px solid #e7e7e7",
                              borderRadius: 1,
                              cursor: "pointer",
                              backgroundColor: "#fff",
                              "&:hover": { backgroundColor: "#FAF9F8" },
                            }}
                            onClick={() =>
                              navigate(
                                paths.dashboard.legal(userData?.ud_id || "")
                              )
                            }
                          >
                            <CardContent
                              sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                p: 2.5,
                                pb: 1,
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={2}
                                alignItems="center"
                              >
                                <Box
                                  sx={{
                                    p: 1,
                                    borderRadius: 1,
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #eeeeee",
                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <SvgIcon>
                                    <FolderOutlinedIcon />
                                  </SvgIcon>
                                </Box>
                                <Typography
                                  color="text.primary"
                                  variant="subtitle1"
                                >
                                  Legal
                                </Typography>
                              </Stack>
                              <Typography
                                color="text.secondary"
                                sx={{ mt: 1, flex: 1 }}
                                variant="body2"
                              >
                                Estate planning, marriage and divorce, business
                                documents.
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <Button
                                color="inherit"
                                endIcon={
                                  <SvgIcon>
                                    <ArrowForwardOutlinedIcon />
                                  </SvgIcon>
                                }
                                size="small"
                                onClick={() =>
                                  navigate(
                                    paths.dashboard.legal(userData?.ud_id || "")
                                  )
                                }
                              >
                                Get started
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>

                        <Grid xs={6} sm={4} lg={3}>
                          <Card
                            variant="outlined"
                            sx={{
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              border: "1px solid #e7e7e7",
                              borderRadius: 1,
                              cursor: "pointer",
                              backgroundColor: "#fff",
                              "&:hover": { backgroundColor: "#FAF9F8" },
                            }}
                            onClick={() =>
                              navigate(
                                paths.dashboard.medical(userData?.ud_id || "")
                              )
                            }
                          >
                            <CardContent
                              sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                p: 2.5,
                                pb: 1,
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={2}
                                alignItems="center"
                              >
                                <Box
                                  sx={{
                                    p: 1,
                                    borderRadius: 1,
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #eeeeee",
                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <SvgIcon>
                                    <MedicationOutlined />
                                  </SvgIcon>
                                </Box>
                                <Typography
                                  color="text.primary"
                                  variant="subtitle1"
                                >
                                  Medical
                                </Typography>
                              </Stack>
                              <Typography
                                color="text.secondary"
                                sx={{ mt: 1, flex: 1 }}
                                variant="body2"
                              >
                                Medical contacts, history, allergies, and
                                current medications.
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <Button
                                color="inherit"
                                endIcon={
                                  <SvgIcon>
                                    <ArrowForwardOutlinedIcon />
                                  </SvgIcon>
                                }
                                size="small"
                                onClick={() =>
                                  navigate(
                                    paths.dashboard.medical(
                                      userData?.ud_id || ""
                                    )
                                  )
                                }
                              >
                                Get started
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>

                        <Grid xs={6} sm={4} lg={3}>
                          <Card
                            variant="outlined"
                            sx={{
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              border: "1px solid #e7e7e7",
                              borderRadius: 1,
                              cursor: "pointer",
                              backgroundColor: "#fff",
                              "&:hover": { backgroundColor: "#FAF9F8" },
                            }}
                            onClick={() =>
                              navigate(
                                paths.dashboard.financial(userData?.ud_id || "")
                              )
                            }
                          >
                            <CardContent
                              sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                p: 2.5,
                                pb: 1,
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={2}
                                alignItems="center"
                              >
                                <Box
                                  sx={{
                                    p: 1,
                                    borderRadius: 1,
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #eeeeee",
                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <SvgIcon>
                                    <AccountBalanceOutlinedIcon />
                                  </SvgIcon>
                                </Box>
                                <Typography
                                  color="text.primary"
                                  variant="subtitle1"
                                >
                                  Financial
                                </Typography>
                              </Stack>
                              <Typography
                                color="text.secondary"
                                sx={{ mt: 1, flex: 1 }}
                                variant="body2"
                              >
                                List of assets, debts, and insurance to ease
                                estate settlement effort.
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <Button
                                color="inherit"
                                endIcon={
                                  <SvgIcon>
                                    <ArrowForwardOutlinedIcon />
                                  </SvgIcon>
                                }
                                size="small"
                                onClick={() =>
                                  navigate(
                                    paths.dashboard.financial(
                                      userData?.ud_id || ""
                                    )
                                  )
                                }
                              >
                                Get started
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>

                        <Grid xs={6} sm={4} lg={3}>
                          <Card
                            variant="outlined"
                            sx={{
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              border: "1px solid #e7e7e7",
                              borderRadius: 1,
                              cursor: "pointer",
                              backgroundColor: "#fff",
                              "&:hover": { backgroundColor: "#FAF9F8" },
                            }}
                            onClick={() =>
                              navigate(
                                paths.dashboard.property(userData?.ud_id || "")
                              )
                            }
                          >
                            <CardContent
                              sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                p: 2.5,
                                pb: 1,
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={2}
                                alignItems="center"
                              >
                                <Box
                                  sx={{
                                    p: 1,
                                    borderRadius: 1,
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #eeeeee",
                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <SvgIcon>
                                    <ApartmentOutlinedIcon />
                                  </SvgIcon>
                                </Box>
                                <Typography
                                  color="text.primary"
                                  variant="subtitle1"
                                >
                                  Property
                                </Typography>
                              </Stack>
                              <Typography
                                color="text.secondary"
                                sx={{ mt: 1, flex: 1 }}
                                variant="body2"
                              >
                                Inventory of vehicles, real estate, family
                                heirlooms, and other personal property.
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <Button
                                color="inherit"
                                endIcon={
                                  <SvgIcon>
                                    <ArrowForwardOutlinedIcon />
                                  </SvgIcon>
                                }
                                size="small"
                                onClick={() =>
                                  navigate(
                                    paths.dashboard.property(
                                      userData?.ud_id || ""
                                    )
                                  )
                                }
                              >
                                Get started
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>

                        <Grid xs={6} sm={4} lg={3}>
                          <Card
                            variant="outlined"
                            sx={{
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              border: "1px solid #e7e7e7",
                              borderRadius: 1,
                              cursor: "pointer",
                              backgroundColor: "#fff",
                              "&:hover": { backgroundColor: "#FAF9F8" },
                            }}
                            onClick={() =>
                              navigate(
                                paths.dashboard.digital(userData?.ud_id || "")
                              )
                            }
                          >
                            <CardContent
                              sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                p: 2.5,
                                pb: 1,
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={2}
                                alignItems="center"
                              >
                                <Box
                                  sx={{
                                    p: 1,
                                    borderRadius: 1,
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #eeeeee",
                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <SvgIcon>
                                    <PhoneAndroidOutlinedIcon />
                                  </SvgIcon>
                                </Box>
                                <Typography
                                  color="text.primary"
                                  variant="subtitle1"
                                >
                                  Digital
                                </Typography>
                              </Stack>
                              <Typography
                                color="text.secondary"
                                sx={{ mt: 1, flex: 1 }}
                                variant="body2"
                              >
                                Social media, cloud storage, photo services, and
                                more digital assets.
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <Button
                                color="inherit"
                                endIcon={
                                  <SvgIcon>
                                    <ArrowForwardOutlinedIcon />
                                  </SvgIcon>
                                }
                                size="small"
                                onClick={() =>
                                  navigate(
                                    paths.dashboard.digital(
                                      userData?.ud_id || ""
                                    )
                                  )
                                }
                              >
                                Get started
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>

                        <Grid xs={6} sm={4} lg={3}>
                          <Card
                            variant="outlined"
                            sx={{
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              border: "1px solid #e7e7e7",
                              borderRadius: 1,
                              cursor: "pointer",
                              backgroundColor: "#fff",
                              "&:hover": { backgroundColor: "#FAF9F8" },
                            }}
                            onClick={() =>
                              navigate(
                                paths.dashboard.legacy(userData?.ud_id || "")
                              )
                            }
                          >
                            <CardContent
                              sx={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                p: 2.5,
                                pb: 1,
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={2}
                                alignItems="center"
                              >
                                <Box
                                  sx={{
                                    p: 1,
                                    borderRadius: 1,
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #eeeeee",
                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <SvgIcon>
                                    <AutoStoriesOutlinedIcon />
                                  </SvgIcon>
                                </Box>
                                <Typography
                                  color="text.primary"
                                  variant="subtitle1"
                                >
                                  Legacy
                                </Typography>
                              </Stack>
                              <Typography
                                color="text.secondary"
                                sx={{ mt: 1, flex: 1 }}
                                variant="body2"
                              >
                                Family history and words of wisdom to pass along
                                to the next generation.
                              </Typography>
                            </CardContent>
                            <CardActions>
                              <Button
                                color="inherit"
                                endIcon={
                                  <SvgIcon>
                                    <ArrowForwardOutlinedIcon />
                                  </SvgIcon>
                                }
                                size="small"
                                onClick={() =>
                                  navigate(
                                    paths.dashboard.legacy(
                                      userData?.ud_id || ""
                                    )
                                  )
                                }
                              >
                                Get started
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>
                      </Grid>
                    </Box>
                  </Stack>
                </Stack>
              </Stack>

              <Stack
                spacing={3}
                sx={{ mb: 8, mt: 4, px: { xs: 0, sm: 2, md: 4 } }}
                id="assets-section"
              >
                <Stack spacing={1.5} sx={{ textAlign: "left" }}>
                  <Typography variant="h5">Your plan for assets</Typography>
                  <Typography sx={{ mt: 2 }} variant="body2">
                    A plan for each asset and how it will move to beneficiaries
                    quickly and efficiently.
                  </Typography>
                </Stack>

                <Box sx={{ mt: 5 }}>
                  <Assets />
                </Box>
              </Stack>
            </Stack>
          </Container>
        </Box>
      </Box>
      <VideoDropDownMenu
        anchorEl={anchorEl}
        onClose={() => {
          setPopoverId(null);
          setAnchorEl(null);
          popover.handleClose();
        }}
        recordingId={popoverId}
        open={popover.open}
        handleRemoveVideo={deleteRecording}
      />
      <VideoAskDialog
        // on close, handleClose, then wait a second and to then call fetchRecordings
        onClose={() => {
          dialog.handleClose();
          if (userData?.ud_id) {
            setTimeout(() => fetchRecordings(userData.ud_id || ""), 1000);
            setTimeout(() => fetchRecordings(userData.ud_id || ""), 3000);
            setTimeout(() => fetchRecordings(userData.ud_id || ""), 5000);
            setTimeout(() => fetchRecordings(userData.ud_id || ""), 7000);
            setTimeout(() => fetchRecordings(userData.ud_id || ""), 10000);
          }
        }}
        open={dialog.open}
        email={user?.username || null}
      />
      {/* <HouseholdContextDialog
        onClose={dialogHousehold.handleClose}
        open={dialogHousehold.open}
      /> */}
      {/* <PlatformCelebrationDialog
        open={celebrationDialogOpen}
        onClose={() => {
          setCelebrationDialogOpen(false);
          // Mark as seen when closing
          if (userData?.ud_id) {
            const celebrationKey = `platform_celebration_shown_${userData.ud_id}`;
            localStorage.setItem(celebrationKey, "true");
          }
        }}
        onContinue={() => {
          setCelebrationDialogOpen(false);
          // Mark as seen when continuing
          if (userData?.ud_id) {
            const celebrationKey = `platform_celebration_shown_${userData.ud_id}`;
            localStorage.setItem(celebrationKey, "true");
          }
        }}
      /> */}
    </>
  );
};
